module.exports = __webpack_public_path__ + "img/key.346bd2d5.svg";